/**
 * PAIGE: a fresh job's setup waiting for Cortexa to start (CapturePoint 7b174664). Inside setup the engine asks an
 * unavailable reader again with a backoff and reports the `setup-waiting-for-reader` activity with how long it has
 * waited; on Paige that is a card starting (5 to 10 minutes, longer when the zone is short), and the setup screen and
 * the job card say so in plain words instead of a step that looks stuck. The engine host stops the wait after 30
 * minutes with `setup-reader-unavailable` and the words below (services/Paige.Engine.Host/SetupReaderWait.cs).
 */
export interface ReaderWait {
  endpoint: string;
  waitedMilliseconds: number;
  limitMilliseconds: number;
}

interface WaitActivity {
  id: string;
  status: string;
  readerWait?: ReaderWait | null;
}

export const cortexaWaitActivity = 'setup-waiting-for-reader';

/** The wait the activity reports while setup waits; null for any other activity or once Cortexa answered. */
export function cortexaWait(activity: WaitActivity | null | undefined): ReaderWait | null {
  if (activity?.id !== cortexaWaitActivity || activity.status !== 'started') return null;
  return activity.readerWait ?? null;
}

/** "Cortexa is starting up (4 min). Setup carries on by itself." */
export function cortexaWaitWords(waitedMilliseconds: number): string {
  const minutes = Math.floor(waitedMilliseconds / 60_000);
  const took = minutes < 1 ? 'under a minute' : `${minutes} min`;
  return `Cortexa is starting up (${took}). Setup carries on by itself.`;
}

export const cortexaWaitHeadline = 'Waiting for Cortexa…';

/** The engine host's words when the wait ran out (SetupReaderWait.Words); the screen offers Resume with them. */
export const setupPausedForCortexa =
  'Cortexa took too long to start, so setup paused. Your documents are kept: resume and setup carries on from them.';
